module.exports = __webpack_public_path__ + "static/media/k5.e54c1f87.jpg";